module.exports = __webpack_public_path__ + "img/K-active.522860b3.png";